module.exports = __webpack_public_path__ + "static/Charity-Times-Award-55e45dc92e7c99ad41df4c7a5780d252.jpg";